class DrawersNavigationSlider extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          spacing: 5,
        },
      },
      [window.BAO.Carousel.useInitialised()],
    )
  }
}

if (!customElements.get('drawers-navigation-slider')) {
  customElements.define('drawers-navigation-slider', DrawersNavigationSlider)
}
